/** Hero banner image focal point — which part of the photo stays visible when cropped. */

export const HERO_IMAGE_FOCAL_DEFAULT = { x: 50, y: 28 };

export function clampFocalPercent(value, fallback) {
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  return Math.min(100, Math.max(0, Math.round(n)));
}

/** @param {{ x?: number|string, y?: number|string }|null|undefined} raw */
export function normalizeHeroImageFocal(raw) {
  return {
    x: clampFocalPercent(raw?.x, HERO_IMAGE_FOCAL_DEFAULT.x),
    y: clampFocalPercent(raw?.y, HERO_IMAGE_FOCAL_DEFAULT.y),
  };
}

/** CSS background-position value for cover crops. */
export function heroImageBackgroundPosition(focal) {
  const { x, y } = normalizeHeroImageFocal(focal);
  return `${x}% ${y}%`;
}

export const HERO_FOCAL_PRESETS = [
  { id: 'top', label: 'Top', x: 50, y: 18 },
  { id: 'center', label: 'Center', x: 50, y: 50 },
  { id: 'bottom', label: 'Bottom', x: 50, y: 82 },
  { id: 'left', label: 'Left', x: 22, y: 50 },
  { id: 'right', label: 'Right', x: 78, y: 50 },
];
